const API_KEY_ENC = 'QUl6YVN5QUwtd1JrUFlEajBXV2llUTBMZHFJdmhSVnpZODBNaFQw';
export default API_KEY_ENC;